// extracted by mini-css-extract-plugin
export default {"value":"OwnReductionToolbar_value__nR7xK","btn":"OwnReductionToolbar_btn__iOslV","wrapper":"OwnReductionToolbar_wrapper__kCOqr","texts":"OwnReductionToolbar_texts__K0wHu"};